import {defineNuxtPlugin} from '#app';
import {datadogRum} from '@datadog/browser-rum';

export default defineNuxtPlugin(nuxtApp => {
  const runtimeConfig = useRuntimeConfig();

  const isLocal =
    process.env.NODE_ENV === 'development' ||
    !runtimeConfig.public.datadogApplicationId ||
    !runtimeConfig.public.datadogClientToken;

  const isE2eVisualTest = !!runtimeConfig.public.e2eVisualTest;

  if (isLocal || isE2eVisualTest) {
    console.info('Datadog RUM disabled for local development');
    return {
      provide: {
        datadogRum: () => ({
          addAction: () => {},
          setUser: () => {},
          identifyUser: () => {},
        }),
      },
    };
  }

  datadogRum.init({
    applicationId: runtimeConfig.public.datadogApplicationId,
    clientToken: runtimeConfig.public.datadogClientToken,
    site: 'us5.datadoghq.com',
    service: 'vector-app',
    env: runtimeConfig.public.datadogEnv || 'production',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: false,
    trackResources: true,
    trackLongTasks: true,
  });

  const router = useRouter();
  router.afterEach(to => {
    nextTick(() => {
      datadogRum.addAction('page_view', {
        page: to.fullPath,
      });
    });
  });

  const identifyUser = async user => {
    const {$propelAuth} = useNuxtApp();
    const auth = await $propelAuth.getAuthenticationInfoOrNull();

    datadogRum.setUser({
      id: user.userId,
      email: user.email,
      name: `${user.firstName} ${user.lastName}`,
      first_name: user.firstName,
      last_name: user.lastName,
      org_id: auth?.orgHelper?.getOrgs()[0]?.orgId,
      org_name: auth?.orgHelper?.getOrgs()[0]?.orgName,
    });
  };

  const user = nuxtApp.$auth?.user;
  if (user) {
    datadogRum.setUser({
      id: user.userId,
      email: user.email,
      name: user.name,
    });
  }

  return {
    provide: {
      datadogRum: () => datadogRum,
      identifyUser,
    },
  };
});
